import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "../src/pages/Home";
import AboutUs from "../src/pages/AboutUs";
import SampleDrawings from "../src/pages/SampleDrawings";
import ContactUs from "../src/pages/ContactUs";
import Footer from "./components/Footer";
import "./App.css";

const App = () => {
  return (
    <Router>
      <Header />
      <div className="main-content">
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/sampledrawings" element={<SampleDrawings />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;
